let Balboa = require('ES/services/Balboa');
let RadioService = require("ES/lib/react-pubsub-via-radio.js/service");

module.exports.init = function () {
	RadioService('ContactGrabber_search', function (params, callback) {
		Balboa.api('/event/contactgrabsearch', params, function (data) {
			callback(null, data.data);
		}, function (data) {
			if (data && data.message && data.errortype && ('ExceptionContactGrabberNotConfigured' === data.errortype)) {
				data.message += ' Click on your username in the upper-right corner, then choose SETTINGS -> CONNECT and choose your contact manager.';
			}
			callback((data && data.message) || 'Failed to search: unknown cause');
		});
	}, function () {
		return 1;
	});

	RadioService('ContactGrabber_grab', function (params, callback) {
		Balboa.api('/event/contactgrab', params, function (data) {
			callback(null, data.data);
		}, function (data) {
			if (data && data.message && data.errortype && ('ExceptionContactGrabberNotConfigured' === data.errortype)) {
				data.message += ' Click on your username in the upper-right corner, then choose SETTINGS -> CONNECT and choose your contact manager.';
			}
			callback((data && data.message) || 'Failed to grab contact: unknown cause');
		});
	}, function () {
		return 1;
	});
};



// WEBPACK FOOTER //
// ./src/services/ContactGrabber.js